/* SILWY Countdown – Custom Element <silwy-countdown data-end="<ms>">. Funktioniert überall (Section, Produkt-Block), unabhängig vom Passwort-Gate. */
(function () {
  if (window.customElements && customElements.get('silwy-countdown')) return;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  class SilwyCountdown extends HTMLElement {
    connectedCallback() {
      this.end = parseInt(this.getAttribute('data-end'), 10);
      if (!this.end) return;
      this.units = {};
      this.querySelectorAll('[data-unit]').forEach((u) => { this.units[u.getAttribute('data-unit')] = u; });
      this.timer = this.querySelector('[data-countdown-timer]');
      this.ended = this.querySelector('[data-countdown-ended]');
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() { clearInterval(this.interval); }

    tick() {
      const diff = Math.max(0, this.end - Date.now());
      const s = Math.floor(diff / 1000);
      if (this.units.d) this.units.d.textContent = pad(Math.floor(s / 86400));
      if (this.units.h) this.units.h.textContent = pad(Math.floor((s % 86400) / 3600));
      if (this.units.m) this.units.m.textContent = pad(Math.floor((s % 3600) / 60));
      if (this.units.s) this.units.s.textContent = pad(s % 60);
      if (diff > 0) return;

      clearInterval(this.interval);
      if (this.getAttribute('data-after-end') === 'hide' && !window.Shopify?.designMode) {
        const wrapper = this.closest('[data-countdown-wrapper]') || this;
        wrapper.hidden = true;
        return;
      }
      if (this.timer) this.timer.hidden = true;
      if (this.ended) this.ended.hidden = false;
    }
  }

  customElements.define('silwy-countdown', SilwyCountdown);
})();

